import React from 'react';

import Document from '@rover/icons/svg/document.svg';
import type { TrainerEducation } from '@rover/rsdk/src/apiClient/latest/model/trainerEducation';

import InfoBox from '../InfoBox';

import QualificationsModal from './QualificationsModal';

const ICON_SIZE = 24;

type QualificationsSectionProps = {
  educationList: TrainerEducation[];
  name: string;
  isTrainerProfileReordering?: boolean;
};

const QualificationsSection: React.FC<QualificationsSectionProps> = ({
  educationList,
  name,
  isTrainerProfileReordering = false,
}) => {
  const educationListString: string = educationList
    .map((entry) => entry.credentialOrganization?.ownerFacingName || entry.text)
    .join(', ');

  const firstName = name.split(' ')[0];

  return (
    <InfoBox isTrainerProfileReordering={isTrainerProfileReordering}>
      <InfoBox.Icon>
        <Document width={ICON_SIZE} height={ICON_SIZE} />
      </InfoBox.Icon>

      {educationList.map((education) => (
        <InfoBox.BoldText
          key={education.opk}
          isTrainerProfileReordering={isTrainerProfileReordering}
          paddingBottom={isTrainerProfileReordering ? '4x' : '0x'}
        >
          {education.credentialOrganization?.ownerFacingName || education.text}
        </InfoBox.BoldText>
      ))}
      {!isTrainerProfileReordering && (
        <>
          <InfoBox.Link>Learn more about credentials</InfoBox.Link>
          <InfoBox.Modal>
            <QualificationsModal firstName={firstName} qualifications={educationListString} />
          </InfoBox.Modal>
        </>
      )}
    </InfoBox>
  );
};

export default QualificationsSection;
